import {tiNormalizer} from '../../util/utils';

const mapDocument = ({
	documentId,
	documentName,
	documentType: documentTypeId,
	engagementId,
	versionNumber,
	fileExtension: fileExt,
	...rest
}) => {
	return {
		...rest,
		documentId,
		documentName,
		documentTypeId,
		engagementId,
		versionNumber,
		fileExt
	};
};

const mapInstructions = ({
	gaInstructionGuid: id,
	gaInstructionName: title,
	gaInstructionDescription: description,
	associatedDocuments: documents = [],
	associatedScopes: scopes = [],
	scopesCount,
	associatedComponents: teams = [],
	teamCount,
	...rest
}) => {
	const mappedDocument = documents?.map(mapDocument);
	return {
		...rest,
		id,
		title,
		description,
		documents: mappedDocument,
		documentCount: documents?.length,
		teams,
		teamCount: teams?.length || 0,
		scopes,
		scopesCount: scopes?.length || 0
	};
};

const mapSections = ({
	instructionSectionId: id,
	instructionSectionName: label,
	knowledgeInstructionSectionId,
	isCustom,
	instructions,
	hashValue = null
}) => {
	const mappedInstructions = instructions.map(mapInstructions);
	return {
		id,
		label,
		isCustom,
		knowledgeInstructionSectionId,
		hashValue,
		count: instructions.length,
		instructions: [
			...tiNormalizer.filterSortKnowledge(mappedInstructions),
			...tiNormalizer.filterSortCustom(mappedInstructions, 'title')
		]
	};
};

export default (data) => {
	const mappedSections = data.map(mapSections);
	return {
		sections: [
			...tiNormalizer.filterSortKnowledge(mappedSections),
			...tiNormalizer.filterSortCustom(mappedSections, 'label')
		]
	};
};
